/*!
 * Productzoeker – Islamboekhandel.nl
 * Stap-voor-stap productkeuzehulp. Vraagt eerst het producttype en stelt
 * daarna vragen die bij dat type horen (parfum, boeken & Koran, kleding, verzorging, cadeau, ...).
 * Producten komen live uit de winkel via collections/<handle>?view=zoeker.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /*  1. Vragen per producttype                                          */
  /* ------------------------------------------------------------------ */

  // Herbruikbare geurrichtingen (parfum + huisgeur)
  var SCENTS = [
    { id: 'zoet', icon: '🍯', label: 'Zoet & warm', sub: 'Vanille, karamel, chocolade', fam: ['gourmand'], kw: ['vanille', 'vanilla', 'karamel', 'caramel', 'chocola', 'choco', 'honing', 'zoet', 'praline'] },
    { id: 'bloemig', icon: '🌹', label: 'Bloemig', sub: 'Roos, jasmijn, witte bloemen', fam: ['bloemig'], kw: ['roos', 'rose', 'jasmijn', 'jasmine', 'bloem', 'flower', 'ward', 'oranjebloesem'] },
    { id: 'oud', icon: '🪵', label: 'Oud, amber & oosters', sub: 'Rijk, warm en Arabisch', fam: ['oosters', 'balsamico'], kw: ['oud', 'oudh', 'amber', 'saffraan', 'saffron', 'dehn', 'oriental', 'agarwood'] },
    { id: 'houtig', icon: '🌲', label: 'Houtig', sub: 'Sandelhout, ceder, leer', fam: ['houtig'], kw: ['sandelhout', 'sandal', 'ceder', 'cedar', 'hout', 'wood', 'vetiver', 'leather'] },
    { id: 'fris', icon: '🍋', label: 'Fris & citrus', sub: 'Licht, schoon en fris', fam: ['fris', 'citrus', 'aquatisch', 'aromatisch'], kw: ['citroen', 'lemon', 'bergamot', 'fris', 'fresh', 'aqua', 'zee', 'munt', 'mint', 'citrus'] },
    { id: 'musk', icon: '🤍', label: 'Zachte musk', sub: 'Schoon, poederig, huidgeur', fam: ['muskusachtig'], kw: ['musk', 'musc', 'muskus', 'tahara', 'poeder', 'powder', 'white musk'] },
    { id: 'fruitig', icon: '🍓', label: 'Fruitig', sub: 'Aardbei, peer, framboos', fam: ['fruitig'], kw: ['aardbei', 'strawberry', 'peer', 'pear', 'framboos', 'appel', 'apple', 'fruit', 'perzik', 'kers', 'cherry'] },
    { id: 'kruidig', icon: '🌶️', label: 'Kruidig', sub: 'Kaneel, peper, kardemom', fam: ['kruidig', 'pittig'], kw: ['kaneel', 'cinnamon', 'peper', 'pepper', 'kardemom', 'kruid', 'spice'] },
    { id: 'verras', icon: '✨', label: 'Verras me', sub: 'Laat de bestsellers zien', none: true }
  ];

  function budgetStep(ranges, extra) {
    var opts = ranges.map(function (r) {
      var label = r[0] === 0 ? 'Tot €' + r[1] : (r[1] >= 9999 ? 'Vanaf €' + r[0] : '€' + r[0] + ' – €' + r[1]);
      return { id: r[0] + '-' + r[1], label: label, budget: [r[0], r[1]], icon: r[2] || '💶' };
    });
    opts.push({ id: 'geen', label: 'Maakt niet uit', icon: '🤷', none: true });
    return Object.assign({ id: 'budget', q: 'Wat is je budget?', hint: 'Per product, ongeveer.', options: opts }, extra || {});
  }

  var PERFUME_TYPES = ['Eau de Parfum', 'Eau de Toilette', 'Parfum', 'Aquaparfum', 'Extrait de Parfum'];

  var FLOWS = [
    {
      id: 'parfum', icon: '🌸', label: 'Parfum', sub: 'Spray, parfumolie & samples',
      sources: ['parfum'],
      more: function (a) { return a.vorm === 'olie' ? 'parfumolie' : a.vorm === 'spray' ? 'parfumspray' : a.vorm === 'proberen' ? 'samplesets' : 'parfum'; },
      steps: [
        { id: 'voor', q: 'Voor wie is de geur?', options: [
          { id: 'haar', icon: '👩', label: 'Voor haar', gender: 'f' },
          { id: 'hem', icon: '👨', label: 'Voor hem', gender: 'm' },
          { id: 'unisex', icon: '🧑‍🤝‍🧑', label: 'Unisex', sub: 'Voor iedereen', gender: 'u' },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        { id: 'vorm', q: 'Welke vorm heeft je voorkeur?', options: [
          { id: 'spray', icon: '💨', label: 'Parfumspray', sub: 'Eau de parfum, flinke fles', types: PERFUME_TYPES },
          { id: 'olie', icon: '💧', label: 'Parfumolie', sub: 'Alcoholvrij, handig rollerflesje', types: ['Parfumolie', 'Pure Geurolie'] },
          { id: 'proberen', icon: '🧪', label: 'Eerst proberen', sub: 'Samplesets & mystery boxen', types: ['Sampleset', 'Bundelparfum', 'Mystery Box', 'Parfumset'] },
          { id: 'body', icon: '🧴', label: 'Body mist & deo', sub: 'Lichte geur voor overdag', types: ['Body Mist', 'Deodorant', 'Body Lotion'] },
          { id: 'geen', icon: '🤷', label: 'Geen voorkeur', none: true }
        ] },
        { id: 'geur', q: 'Welke geuren vind je lekker?', hint: 'Kies er maximaal twee.', multi: 2, must: true, options: SCENTS },
        { id: 'moment', q: 'Wanneer wil je hem vooral dragen?', options: [
          { id: 'dag', icon: '☀️', label: 'Elke dag', sub: 'Werk, school, boodschappen', occ: ['elke dag', 'casual'] },
          { id: 'speciaal', icon: '🌙', label: 'Speciale momenten', sub: 'Eid, bruiloft, avond', occ: ['speciale gelegenheid', 'formal'], kw: ['intense', 'elixir', 'extrait', 'oud', 'royal', 'prive'] },
          { id: 'cadeau', icon: '🎁', label: 'Als cadeau', sub: 'Mooi verpakt geven', tags: ['cadeau', 'topcadeau', 'eid cadeau'], kw: ['set', 'cadeau', 'gift'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 10, '🪙'], [10, 25], [25, 45], [45, 9999, '💎']])
      ]
    },
    {
      id: 'boeken', icon: '📚', label: 'Boeken & Koran', sub: 'Boeken, kinderboeken en Koranuitgaven',
      sources: function (a) { return a.voor === 'koran' ? ['koran-quran'] : a.voor === 'kind' ? ['islamitische-kinderboeken'] : ['islamitische-boeken']; },
      more: function (a) {
        if (a.voor === 'koran') return a.doel === 'leren' ? 'koran-tajweed' : a.doel === 'arabisch' ? 'koran-arabisch' : a.doel === 'uitleg' ? 'tafsir' : 'koran-quran';
        if (a.voor === 'kind') return 'islamitische-kinderboeken';
        if (a.taal === 'en') return 'engelse-boeken';
        if (a.taal === 'ar') return 'arabische-boeken';
        return a.niveau === 'nieuw' ? 'beginners-basis-islam' : 'islamitische-boeken';
      },
      steps: [
        { id: 'voor', q: 'Wat zoek je?', options: [
          { id: 'zelf', icon: '🧔', label: 'Boek voor volwassenen', sub: 'Voor mezelf of een ander', age: 'volw', excludeTypes: ['Kinderboek', 'Koran', 'Koranhouder', 'Boekenlegger'] },
          { id: 'tiener', icon: '🧑‍🎓', label: 'Boek voor tieners', sub: '12 – 18 jaar', age: 'tiener', excludeTypes: ['Koran', 'Koranhouder', 'Boekenlegger'] },
          { id: 'kind', icon: '🧒', label: 'Kinderboek', sub: '0 – 12 jaar', excludeTypes: ['Koran', 'Koranhouder', 'Boekenlegger'] },
          { id: 'koran', icon: '📖', label: 'Een Koran', sub: 'Arabisch, vertaald of tajweed', types: ['Koran', 'Arabische Boek', 'Boek', 'Kinderboek', 'Engelse Boek'] }
        ] },
        { id: 'leeftijd', q: 'Hoe oud is het kind?', when: { voor: ['kind'] }, options: [
          { id: 'baby', icon: '👶', label: '0 – 3 jaar', sub: 'Baby & peuter', age: 'baby', cols: ['baby-peuterboeken'] },
          { id: 'kleuter', icon: '🧸', label: '3 – 6 jaar', sub: 'Kleuter', age: 'kleuter' },
          { id: 'kind6', icon: '🎒', label: '6 – 9 jaar', sub: 'Groep 3 – 5', age: 'kind6' },
          { id: 'kind9', icon: '📖', label: '9 – 12 jaar', sub: 'Groep 6 – 8', age: 'kind9' }
        ] },
        { id: 'soort', q: 'Wat voor boek zoek je?', hint: 'Kies er maximaal twee.', multi: 2, must: true, when: { voor: ['kind'] }, options: [
          { id: 'verhalen', icon: '🌙', label: 'Voorleesverhalen', sub: 'Mooie islamitische verhalen', cols: ['kinderverhalen'], kw: ['verhaal', 'verhalen', 'story', 'stories'] },
          { id: 'profeten', icon: '🕋', label: 'Koran & profeten', sub: 'Verhalen uit de Koran', cols: ['verhalen-koran'], kw: ['profeet', 'profeten', 'prophet', 'koran', 'quran'] },
          { id: 'leren', icon: '💡', label: 'Leren & weetjes', sub: 'Educatief, Arabisch, dua', cols: ['educatieve-kinderboeken', 'arabisch-leren'], kw: ['leren', 'mijn eerste', 'weetjes', 'alfabet', 'dua', 'woorden'] },
          { id: 'doen', icon: '✏️', label: 'Doe-, kleur- & werkboek', sub: 'Lekker zelf bezig', cols: ['werk-speelboek', 'kleur-knutselboeken'], kw: ['kleur', 'activiteit', 'werkboek', 'doeboek', 'sticker', 'puzzel'] },
          { id: 'ramadan', icon: '🏮', label: 'Ramadan & Eid', sub: 'Voor de mooiste maand', cols: ['ramadan-boeken', 'ramadan-werkboek-kalender'], kw: ['ramadan', 'eid', 'suikerfeest'] }
        ] },
        { id: 'niveau', q: 'Hoeveel weet je al over de islam?', when: { voor: ['zelf', 'tiener'] }, options: [
          { id: 'nieuw', icon: '🌱', label: 'Ik begin net', sub: 'Of ik zoek iets voor een nieuwe moslim', cols: ['beginners-basis-islam', 'introductie-tot-islam-beginners', 'top-10-boek-beginners'], kw: ['beginners', 'introductie', 'basis'] },
          { id: 'basis', icon: '📘', label: 'Ik heb basiskennis', sub: 'Ik wil verder leren', cols: ['basis-islam', 'top-25-boeken'] },
          { id: 'verdieping', icon: '🎓', label: 'Ik wil me verdiepen', sub: 'Uitgebreide, verdiepende werken', cols: ['aqiedah-tawheed', 'fiqh-islamitische-recht', 'tafsir', 'biografie-sirah-geschiedenis'], nkw: ['beginners', 'voor kinderen'] }
        ] },
        { id: 'onderwerp', q: 'Over welk onderwerp?', hint: 'Kies er maximaal twee.', multi: 2, must: true, when: { voor: ['zelf', 'tiener'] }, options: [
          { id: 'basis', icon: '🕌', label: 'Basis van de islam', sub: 'Pilaren, geloof, praktijk', cols: ['beginners-basis-islam', 'basis-islam', 'introductie-tot-islam-beginners'] },
          { id: 'profeet', icon: '🌴', label: 'Profeet & geschiedenis', sub: 'Sirah, metgezellen, biografie', cols: ['mohammed-vzmh', 'biografie-sirah-geschiedenis', 'biografie-geschiedenis'], kw: ['profeet', 'sirah', 'metgezellen', 'sahaba'] },
          { id: 'gebed', icon: '🤲', label: 'Gebed, dua & Ramadan', sub: 'Salat, smeekbeden, vasten, hadj', cols: ['gebed-salat', 'smeekgebed-dua', 'ramadan-boeken', 'hadj-umrah'], kw: ['gebed', 'salat', 'dua', "doe'a", 'hisnul', 'ramadan', 'hadj', 'umrah'] },
          { id: 'geloof', icon: '✨', label: 'Geloofsleer', sub: 'Aqiedah, tawhied, hiernamaals', cols: ['aqiedah-tawheed', 'dood-hiernamaals', 'djinn-duivels-engelen'] },
          { id: 'gezin', icon: '🏡', label: 'Huwelijk & opvoeding', sub: 'Gezin, kinderen, de moslimvrouw', cols: ['gezin-huwelijk-opvoeding', 'huwelijk', 'geboorte-opvoeding-islam', 'moslimvrouw'] },
          { id: 'groei', icon: '🌿', label: 'Karakter & persoonlijke groei', sub: 'Akhlaaq, berouw, het hart', cols: ['persoonlijke-groei-zelfhulpboeken', 'akhlaaq-gebruiken-gewoontes-islam', 'zonden-berouw', 'ziekte-genezing'] },
          { id: 'koran', icon: '📖', label: 'Koranuitleg', sub: 'Tafsir en Koranverhalen', cols: ['tafsir', 'verhalen-koran'] },
          { id: 'arabisch', icon: 'ع', label: 'Arabisch leren', sub: 'Lesboeken en woordenboeken', cols: ['arabisch-leren'], kw: ['arabisch', 'arabic', 'madinah'] }
        ] },
        { id: 'taal', q: 'In welke taal?', when: { voor: ['zelf', 'tiener', 'kind'] }, options: [
          { id: 'nl', icon: '🇳🇱', label: 'Nederlands', lang: ['Nederlands', 'Nederlands - Arabisch'] },
          { id: 'en', icon: '🇬🇧', label: 'Engels', lang: ['Engels', 'Engels - Arabisch'], cols: ['engelse-boeken'] },
          { id: 'ar', icon: '🌙', label: 'Arabisch', lang: ['Arabisch', 'Nederlands - Arabisch', 'Engels - Arabisch'], cols: ['arabische-boeken'] },
          { id: 'tweetalig', icon: '🔁', label: 'Tweetalig', sub: 'Met Arabische tekst erbij', lang: ['Nederlands - Arabisch', 'Engels - Arabisch'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        { id: 'doel', q: 'Waarvoor zoek je een Koran?', must: true, when: { voor: ['koran'] }, options: [
          { id: 'arabisch', icon: '🕌', label: 'Lezen in het Arabisch', sub: 'Mushaf zonder vertaling', cols: ['koran-arabisch'], lang: ['Arabisch'], nkw: ['vertaling', 'translation', 'transliteratie', 'fonetisch'] },
          { id: 'begrijpen', icon: '💬', label: 'Begrijpen', sub: 'Arabisch met vertaling', kw: ['vertaling', 'translation', 'nederlands', 'english', 'clear quran', 'betekenis'] },
          { id: 'leren', icon: '🎓', label: 'Leren lezen', sub: 'Tajweed of fonetisch (transliteratie)', cols: ['koran-tajweed', 'koran-nederlandstransliteratie'], kw: ['tajweed', 'fonetisch', 'transliteratie', 'transliteration'] },
          { id: 'uitleg', icon: '🔎', label: 'Uitleg (tafsir)', sub: 'Wat betekenen de verzen?', cols: ['tafsir'], kw: ['tafsir', 'uitleg', 'ibn kathir'] },
          { id: 'kind', icon: '🧒', label: 'Voor een kind', sub: 'Djoez Amma & kinderkoran', cols: ['djoez-amma'], kw: ['djoez', 'juz', 'amma', 'kind', 'kids'] }
        ] },
        { id: 'ktaal', q: 'Welke vertaling wil je erbij?', when: { voor: ['koran'], doel: ['begrijpen', 'leren', 'uitleg', 'kind'] }, options: [
          { id: 'nl', icon: '🇳🇱', label: 'Nederlands', lang: ['Nederlands', 'Nederlands - Arabisch'], kw: ['nederlands'] },
          { id: 'en', icon: '🇬🇧', label: 'Engels', lang: ['Engels', 'Engels - Arabisch'], kw: ['english', 'engels'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        { id: 'formaat', q: 'Welk formaat?', must: true, when: { voor: ['koran'] }, options: [
          { id: 'pocket', icon: '👜', label: 'Klein / pocket', sub: 'Handig voor onderweg', kw: ['pocket', 'mini', 'klein', 'small', '9x12', '10x14', '8x12', 'reis'] },
          { id: 'normaal', icon: '📗', label: 'Normaal', sub: 'Voor dagelijks gebruik thuis', kw: ['medium', '14x20', '17x24', '15x21', 'a5'], nkw: ['pocket', 'mini', 'klein', 'groot', 'large', 'xl'], hitIfNot: true },
          { id: 'groot', icon: '📕', label: 'Groot', sub: 'Groot, goed leesbaar schrift', kw: ['groot', 'large', 'big', '20x28', '24x34', '25x35', 'xl'] },
          { id: 'geen', icon: '🤷', label: 'Geen voorkeur', none: true }
        ] },
        { id: 'stijl', q: 'Hoe mag hij eruitzien?', when: { voor: ['koran'] }, options: [
          { id: 'praktisch', icon: '📘', label: 'Eenvoudig & praktisch', sub: 'Om veel in te lezen' },
          { id: 'luxe', icon: '🎁', label: 'Luxe / als cadeau', sub: 'Leren of fluwelen kaft, mooi verpakt', kw: ['leer', 'leren', 'fluweel', 'velvet', 'goud', 'gold', 'cadeau', 'box', 'luxe', 'regenboog', 'rainbow'], kaft: ['Thermoleer', 'Fluweel'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 10, '🪙'], [10, 20], [20, 35], [35, 9999, '💎']], { when: { voor: ['zelf', 'tiener', 'kind'] } }),
        budgetStep([[0, 15, '🪙'], [15, 30], [30, 50], [50, 9999, '💎']], { id: 'kbudget', when: { voor: ['koran'] } })
      ]
    },
    {
      id: 'kleding', icon: '🧕', label: 'Kleding', sub: 'Abaya, hijab, heren & kinderen',
      sources: function (a) {
        if (a.voor !== 'hadj') return ['kleding', 'ihram'];
        return a.hadjwat === 'hvrouw' ? ['kleding', 'gebedskleding'] : ['ihram', 'hadj-umrah'];
      },
      more: function (a) {
        if (a.voor === 'hadj') return a.hadjwat === 'hvrouw' ? 'kleding' : 'ihram';
        return a.wat === 'gebed' ? 'gebedskleding' : 'kleding';
      },
      steps: [
        { id: 'voor', q: 'Voor wie is de kleding?', must: true, options: [
          { id: 'vrouw', icon: '👩', label: 'Een vrouw', gender: 'f', excludeTypes: ['Kinderkleding', 'Kinderhoofddoek', 'Herenkleding', 'Kapje', 'ihraam'] },
          { id: 'man', icon: '👨', label: 'Een man', sub: 'Qamis, thobe, ihram', gender: 'm', types: ['Herenkleding', 'ihraam', 'Kapje', 'Gebedskleding'] },
          { id: 'kind', icon: '🧒', label: 'Een kind', sub: 'Meisjes en jongens', age: 'kind', types: ['Kinderkleding', 'Kinderhoofddoek', 'Hoofddoek', 'Kleding', 'Abaya', 'Abaya Set', 'Abaya & Khimarset'], kw: ['kind', 'kinder', 'kinderen', 'kids', 'binti', 'baby', 'meisje', 'jongen', 'junior'] },
          { id: 'hadj', icon: '🕋', label: 'Hadj & Umrah', sub: 'Ihram, ihramriem en kleding voor onderweg' }
        ] },
        { id: 'hadjwat', q: 'Wat zoek je voor Hadj of Umrah?', must: true, when: { voor: ['hadj'] }, options: [
          { id: 'hman', icon: '👨', label: 'Ihram voor mannen', sub: 'Ihram-set van katoen of bamboe', types: ['ihraam', 'Hadj Artikelen'], kw: ['ihram', 'ihraam'], xkw: ['kinderen', 'kind', 'riem', 'opbergriem', 'nektasje', 'ballonnen', 'ballon'] },
          { id: 'hkind', icon: '🧒', label: 'Ihram voor kinderen', sub: 'Ihram-set voor jongens', types: ['ihraam', 'Hadj Artikelen'], kw: ['kinderen', 'kids'], rkw: ['kinderen', 'kids'] },
          { id: 'hvrouw', icon: '🧕', label: 'Voor een vrouw', sub: 'Abaya, gebedskleding en hijab voor onderweg', gender: 'f', types: ['Abaya', 'Abaya Set', 'Abaya & Khimarset', 'Gebedskleding', 'Khimaar', 'Hoofddoek'], xkw: ['kinderen', 'kinder', 'meisjes', 'meisje', 'kids', 'baby', 'peuter'] },
          { id: 'hriem', icon: '🧳', label: 'Ihramriem & accessoires', sub: 'Opbergriem, ihram-riem en nektasje', types: ['Hadj Artikelen'], kw: ['riem', 'opbergriem', 'nektasje', 'gesp'], rkw: ['riem', 'opbergriem', 'nektasje', 'gesp', 'gordel'] }
        ] },
        { id: 'wat', q: 'Wat zoek je?', must: true, when: { voor: ['vrouw'] }, options: [
          { id: 'abaya', icon: '🧕', label: 'Abaya & kaftan', sub: 'Abaya, abaya-set of khimarset', types: ['Abaya', 'Abaya Set', 'Abaya & Khimarset'] },
          { id: 'jurk', icon: '👕', label: 'Jurken & setjes', sub: 'Jurk, ensemble, twinset, broekpak', types: ['Kleding', 'Twinset'], kw: ['jurk', 'ensemble', 'twinset', 'broekpak', 'rok', 'dress', 'blouse', 'set'], nkw: ['gebedskleding', 'baby'] },
          { id: 'jas', icon: '☁️', label: 'Jassen & winterkleding', sub: 'Jas, parka, poncho, vest', types: ['Kleding', 'Twinset'], kw: ['jas', 'jasje', 'parka', 'poncho', 'blazer', 'vest', 'spencer', 'winter', 'gewatteerd'] },
          { id: 'hijab', icon: '🧕', label: 'Hijab & khimaar', sub: 'Hoofddoek, instant hijab, khimaar', types: ['Hoofddoek', 'Khimaar'] },
          { id: 'gebed', icon: '🤲', label: 'Gebedskleding', sub: 'Gebedsjurk en gebedsset', types: ['Gebedskleding', 'Kleding'], kw: ['gebedskleding', 'gebedsjurk', 'isdal', 'gebed'], cols: ['gebedskleding'] },
          { id: 'zwem', icon: '☀️', label: 'Burkini', sub: 'Zwemkleding voor strand en zwembad', types: ['Burkini'] }
        ] },
        { id: 'stijl', q: 'Welke stijl past bij je?', when: { voor: ['vrouw', 'kind'] }, options: [
          { id: 'dagelijks', icon: '☀️', label: 'Dagelijks & praktisch', sub: 'Comfortabel, makkelijk te combineren', kw: ['basic', 'katoen', 'jersey', 'dagelijks', 'casual', 'comfort', 'praktisch', 'soft'] },
          { id: 'feest', icon: '✨', label: 'Feestelijk & elegant', sub: 'Voor Eid, een bruiloft of een mooie avond', kw: ['satijn', 'feest', 'elegant', 'kant', 'luxe', 'glans', 'pailletten', 'fluweel', 'velvet', 'chiffon', 'jawhara'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 25, '🪙'], [25, 45], [45, 65], [65, 9999, '💎']])
      ]
    },
    {
      id: 'verzorging', icon: '🧴', label: 'Verzorging', sub: 'Huid, haar, hamam & natuurlijke oliën',
      sources: function (a) {
        return { lichaam: ['verzorgingsproducten', 'hamam'], haar: ['haarolie', 'verzorgingsproducten'], deo: ['deodorant'], hamam: ['hamam', 'verzorgingsproducten'], olie: ['etherische-olie', 'massage-olie', 'basis-olie'], henna: ['henna'], siwak: ['siwak', 'verzorgingsproducten'] }[a.wat] || ['verzorgingsproducten'];
      },
      more: function (a) { return { lichaam: 'verzorgingsproducten', haar: 'haarolie', deo: 'deodorant', hamam: 'hamam', olie: 'etherische-olie', henna: 'henna', siwak: 'siwak' }[a.wat] || 'verzorgingsproducten'; },
      steps: [
        { id: 'wat', q: 'Waar zoek je verzorging voor?', must: true, options: [
          { id: 'lichaam', icon: '🧴', label: 'Lichaam & huid', sub: 'Bodylotion, zeep, bad & douche', types: ['Body Lotion', 'Verzorging', 'Bad&Douche'], kw: ['bodylotion', 'lotion', 'zeep', 'soap', 'douche', 'bad', 'crème', 'creme', 'boter', 'butter'], nkw: ['shampoo', 'conditioner', 'haarmasker', 'tandpasta', 'siwak'] },
          { id: 'haar', icon: '💧', label: 'Haar & baard', sub: 'Haarolie, shampoo, conditioner', types: ['Haarolie', 'Verzorging'], kw: ['haar', 'shampoo', 'conditioner', 'haarmasker', 'baard', 'hair'], cols: ['haarolie'] },
          { id: 'deo', icon: '💨', label: 'Deodorant', sub: 'Spray en roller', types: ['Deodorant'] },
          { id: 'hamam', icon: '✨', label: 'Hamam & scrub', sub: 'Scrub, kessa, zwarte zeep', types: ['Hamam', 'Verzorging', 'Bad&Douche'], kw: ['hamam', 'scrub', 'kessa', 'peeling', 'zwarte zeep', 'badzout'], cols: ['hamam'] },
          { id: 'olie', icon: '🌿', label: 'Natuurlijke oliën', sub: 'Etherische, massage- en basisolie', types: ['Etherische Olie', 'Massage Olie', 'Basisolie'] },
          { id: 'henna', icon: '🖍️', label: 'Henna', sub: 'Henna, kegels en poeder', types: ['Henna'] },
          { id: 'siwak', icon: '🌱', label: 'Siwak & mondverzorging', sub: 'Siwak en tandpasta', types: ['Siwak', 'Verzorging'], kw: ['siwak', 'siwaak', 'miswak', 'tandpasta', 'tand'], cols: ['siwak'] }
        ] },
        { id: 'wens', q: 'Waar let je op?', hint: 'Kies er maximaal twee.', multi: 2, options: [
          { id: 'natuur', icon: '🌿', label: 'Natuurlijk & plantaardig', sub: 'Zoals argan, amandel, kokos of zwarte zaad', kw: ['natuurlijk', 'natural', 'organic', 'bio', 'plantaardig', 'vegan', 'argan', 'zwarte zaad', 'black seed', 'kokos', 'amandel', 'olijf', 'aloe', 'shea'] },
          { id: 'alcoholvrij', icon: '💧', label: 'Alcoholvrij', sub: 'Als dat in de naam of omschrijving staat', kw: ['alcoholvrij', 'alcohol free', 'alcohol-free'] },
          { id: 'geur', icon: '🌸', label: 'Lekkere geur', sub: 'Musk, oud, roos, vanille', kw: ['musk', 'oud', 'vanille', 'roos', 'rose', 'jasmijn', 'amber', 'bloem', 'geur'] },
          { id: 'cadeau', icon: '🎁', label: 'Mooi om te geven', kw: ['cadeau', 'set', 'box', 'gift', 'geschenk'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 7, '🪙'], [7, 15], [15, 30], [30, 9999, '💎']])
      ]
    },
    {
      id: 'cadeau', icon: '🎁', label: 'Een cadeau', sub: 'Voor Eid, geboorte, huwelijk…',
      sources: function (a) {
        var extra = { geur: 'parfum', boek: 'top-25-boeken', gebed: 'gebed-dhikr-producten', deco: 'decoratie' }[a.soort];
        var s = ['cadeau', 'cadeaupakket'];
        if (a.voor === 'kind') s.push('speelgoed-spellen');
        if (extra) s.push(extra);
        return s;
      },
      tip: { text: 'Tip: maak het af met mooie cadeauverpakking.', handle: 'cadeauverpakking', label: 'Bekijk cadeauverpakking' },
      more: function () { return 'cadeau'; },
      steps: [
        { id: 'voor', q: 'Voor wie is het cadeau?', options: [
          { id: 'vrouw', icon: '👩', label: 'Een vrouw', sub: 'Moeder, zus, vriendin', gender: 'f' },
          { id: 'man', icon: '👨', label: 'Een man', sub: 'Vader, broer, vriend', gender: 'm' },
          { id: 'kind', icon: '🧒', label: 'Een kind', age: 'kind', cols: ['speelgoed-spellen', 'islamitische-kinderboeken', 'poppen-knuffels'], types: ['Kinderboek', 'Spel & Speelgoed', 'Spel', 'Poppen & Knuffels', 'Kinderkleding', 'Schoolspullen', 'Kinderhoofddoek', 'Cadeauset', 'Mystery Box'] },
          { id: 'stel', icon: '💑', label: 'Een stel of gezin', kw: ['koppel', 'hem en haar', 'samen', 'gezin', 'huis', 'set'] }
        ] },
        { id: 'moment', q: 'Wat is de gelegenheid?', options: [
          { id: 'eid', icon: '🌙', label: 'Eid', cols: ['top25-eid-cadeaus', 'eid-decoratie'], tags: ['eid cadeau', 'eid cadeaus', 'eidmubarak'], kw: ['eid'] },
          { id: 'ramadan', icon: '🏮', label: 'Ramadan', cols: ['ramadan-producten', 'top-25-ramadan-boeken-en-producten'], kw: ['ramadan'] },
          { id: 'geboorte', icon: '👶', label: 'Geboorte', kw: ['baby', 'geboorte', 'aqiqah', 'newborn', 'kraam'] },
          { id: 'huwelijk', icon: '💍', label: 'Huwelijk', cols: ['huwelijk'], kw: ['huwelijk', 'bruid', 'nikah', 'koppel', 'hem en haar', 'wedding'] },
          { id: 'hadj', icon: '🕋', label: 'Hadj of Umrah', cols: ['hadj-umrah'], kw: ['hadj', 'hajj', 'umrah', 'zamzam', 'mekka', 'makkah'] },
          { id: 'nieuw', icon: '🌱', label: 'Nieuwe moslim', sub: 'Bekering / shahada', cols: ['beginners-basis-islam', 'introductie-tot-islam-beginners'], kw: ['beginners', 'nieuwe moslim', 'shahada', 'starterspakket'] },
          { id: 'zomaar', icon: '💛', label: 'Zomaar', sub: 'Of een verjaardag', none: true }
        ] },
        { id: 'soort', q: 'Waar denk je aan?', options: [
          { id: 'geur', icon: '🌸', label: 'Geur & verzorging', types: PERFUME_TYPES.concat(['Parfumolie', 'Parfumset', 'Cadeauset', 'Body Mist', 'Bakhour', 'Wierook & Bakhour', 'Verzorging']), cols: ['parfum'] },
          { id: 'boek', icon: '📚', label: 'Een boek of Koran', types: ['Boek', 'Koran', 'Kinderboek', 'Engelse Boek', 'Arabische Boek', 'Voordeelbundel Boeken', 'Cadeauset'] },
          { id: 'gebed', icon: '📿', label: 'Gebed & dhikr', sub: 'Tasbih, gebedskleed', types: ['Tasbeeh', 'Gebedskleed', 'Gebedskleding', 'Koranhouder', 'Elektronica', 'Cadeauset'] },
          { id: 'deco', icon: '🖼️', label: 'Iets voor in huis', sub: 'Decoratie & kalligrafie', types: ['Wonen', 'Lijstjes & Bordjes', 'Poster', 'Kalender', 'Koranhouder'] },
          { id: 'pakket', icon: '🎀', label: 'Een kant-en-klaar pakket', sub: 'Cadeausets & mystery boxen', types: ['Cadeauset', 'Mystery Box', 'Parfumset', 'Voordeelbundel Boeken'], cols: ['cadeaupakket'] },
          { id: 'verras', icon: '✨', label: 'Verras me', none: true }
        ] },
        budgetStep([[0, 15, '🪙'], [15, 30], [30, 50], [50, 9999, '💎']])
      ]
    },
    {
      id: 'gebed', icon: '📿', label: 'Gebed & dhikr', sub: 'Gebedskleed, tasbih, kleding',
      sources: ['gebed-dhikr-producten', 'gebedskleedgebedskleden', 'tasbih', 'gebedskleding', 'koranhouder', 'elektronica', 'dua-doea-bordjes'],
      more: function (a) { return { kleed: 'gebedskleedgebedskleden', tasbih: 'tasbih', kleding: 'gebedskleding', houder: 'koranhouder', digitaal: 'elektronica', deco: 'dua-doea-bordjes' }[a.wat] || 'gebed-dhikr-producten'; },
      steps: [
        { id: 'wat', q: 'Wat zoek je?', options: [
          { id: 'kleed', icon: '🧎', label: 'Gebedskleed', types: ['Gebedskleed'], cols: ['gebedskleedgebedskleden'] },
          { id: 'tasbih', icon: '📿', label: 'Tasbih', sub: 'Gebedskralen of teller', types: ['Tasbeeh'], cols: ['tasbih'] },
          { id: 'kleding', icon: '🧕', label: 'Gebedskleding', sub: 'Isdal, khimaar, ihraam', types: ['Gebedskleding', 'Khimaar', 'Hoofddoek', 'ihraam', 'Abaya', 'Kinderhoofddoek'], cols: ['gebedskleding'] },
          { id: 'houder', icon: '📖', label: 'Koranhouder', sub: 'Rahl / leesstandaard', types: ['Koranhouder'], cols: ['koranhouder'] },
          { id: 'digitaal', icon: '🔊', label: 'Elektronica', sub: 'Adhan-klok, Koranspeaker', types: ['Elektronica'], cols: ['elektronica'] },
          { id: 'deco', icon: '🖼️', label: 'Dua-bordjes & stickers', types: ['Lijstjes & Bordjes', 'Stickers & Magneten', 'Wonen'], cols: ['dua-doea-bordjes'] }
        ] },
        { id: 'voor', q: 'Voor wie?', options: [
          { id: 'vrouw', icon: '👩', label: 'Een vrouw', gender: 'f', nkw: ['kind', 'kinder', 'kids', 'meisje', 'meisjes', 'jongen'] },
          { id: 'man', icon: '👨', label: 'Een man', gender: 'm', nkw: ['kind', 'kinder', 'kids', 'meisje', 'jongen'] },
          { id: 'kind', icon: '🧒', label: 'Een kind', age: 'kind', kw: ['kind', 'kinder', 'kids', 'junior', 'jongen', 'meisje'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        { id: 'extra', q: 'Waar moet het vooral goed in zijn?', options: [
          { id: 'reis', icon: '🧳', label: 'Handig op reis', sub: 'Licht, opvouwbaar, pocket', kw: ['reis', 'travel', 'pocket', 'opvouwbaar', 'compact', 'mini', 'zak'] },
          { id: 'comfort', icon: '☁️', label: 'Comfort & kwaliteit', sub: 'Dik, zacht, stevig', kw: ['dik', 'zacht', 'soft', 'foam', 'luxe', 'premium', 'fluweel', 'velvet', 'hout', 'massief'] },
          { id: 'mooi', icon: '🎁', label: 'Mooi om te geven', kw: ['cadeau', 'set', 'box', 'gift', 'luxe', 'goud'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 10, '🪙'], [10, 25], [25, 50], [50, 9999, '💎']])
      ]
    },
    {
      id: 'huisgeur', icon: '🕯️', label: 'Huisgeur & bakhour', sub: 'Bakhour, roomspray, auto',
      sources: ['bakhour-wierook', 'huisparfum', 'luchtverfrisser', 'autoparfum', 'geurblokjes', 'geurolie'],
      more: function (a) { return { bakhour: 'bakhour-wierook', brander: 'bakhour-wierook', huis: 'huisparfum', auto: 'autoparfum', kast: 'geurblokjes', olie: 'geurolie' }[a.waar] || 'luchtverfrisser'; },
      steps: [
        { id: 'waar', q: 'Wat zoek je?', options: [
          { id: 'bakhour', icon: '🪔', label: 'Bakhour & wierook', sub: 'Om te branden', types: ['Bakhour', 'Bakhoursnippers', 'Bakhourtablet', 'Wierook & Bakhour', 'Hars'] },
          { id: 'brander', icon: '🏺', label: 'Een brander', sub: 'Mabkhara of houder', types: ['Brander & Houder', 'Elektronica'], kw: ['brander', 'mabkhara', 'burner', 'houder'] },
          { id: 'huis', icon: '🏠', label: 'Geur in huis', sub: 'Roomspray, geurstokjes', types: ['Roomspray', 'Geurstokjes', 'Kamerverfrisser', 'Luchtverfrisser'] },
          { id: 'olie', icon: '💧', label: 'Geurolie', sub: 'Voor brander of diffuser', types: ['Geurolie'] },
          { id: 'auto', icon: '🚗', label: 'In de auto', types: ['Autoparfum', 'Autogeurhanger'] },
          { id: 'kast', icon: '👕', label: 'Kast & kleding', sub: 'Geurblokjes', types: ['Geurblokje'] }
        ] },
        { id: 'geur', q: 'Welke geur zoek je?', hint: 'Kies er maximaal twee.', multi: 2, must: true, when: { waar: ['bakhour', 'huis', 'olie', 'auto', 'kast'] }, options: SCENTS },
        budgetStep([[0, 8, '🪙'], [8, 15], [15, 30], [30, 9999, '💎']])
      ]
    },
    {
      id: 'kids', icon: '🧸', label: 'Voor kinderen', sub: 'Speelgoed, spellen, school',
      sources: ['speelgoed-spellen', 'poppen-knuffels', 'islamitische-schoolspullen', 'islamitische-quiz-kaarten', 'kleur-knutselboeken'],
      more: function () { return 'speelgoed-spellen'; },
      steps: [
        { id: 'leeftijd', q: 'Hoe oud is het kind?', options: [
          { id: 'baby', icon: '👶', label: '0 – 3 jaar', age: 'baby' },
          { id: 'kleuter', icon: '🧸', label: '3 – 6 jaar', age: 'kleuter' },
          { id: 'kind6', icon: '🎒', label: '6 – 9 jaar', age: 'kind6' },
          { id: 'kind9', icon: '⚽', label: '9 – 12 jaar', age: 'kind9' },
          { id: 'tiener', icon: '🧑‍🎓', label: '12+ jaar', age: 'tiener' }
        ] },
        { id: 'soort', q: 'Waar heeft het kind zin in?', hint: 'Kies er maximaal twee.', multi: 2, must: true, options: [
          { id: 'spel', icon: '🎲', label: 'Spellen & quiz', types: ['Spel', 'Spel & Speelgoed'], cols: ['islamitische-quiz-kaarten'], kw: ['spel', 'quiz', 'kaarten', 'memory', 'game', 'bordspel'] },
          { id: 'knuffel', icon: '🧸', label: 'Knuffels & poppen', types: ['Poppen & Knuffels'], cols: ['poppen-knuffels'] },
          { id: 'bouwen', icon: '🧱', label: 'Bouwen & puzzelen', kw: ['bouw', 'puzzel', 'puzzle', 'blokjes', 'blokken', 'lego', 'bouwstenen'] },
          { id: 'leren', icon: '💡', label: 'Spelend leren', sub: 'Koran, Arabisch, dua', kw: ['leren', 'arabisch', 'arabic', 'koran', 'quran', 'alfabet', 'letters', 'educatief', 'dua', 'woorden'] },
          { id: 'creatief', icon: '🖍️', label: 'Kleuren & knutselen', cols: ['kleur-knutselboeken'], types: ['Stickers & Magneten'], kw: ['kleur', 'knutsel', 'sticker', 'tekenen'] },
          { id: 'school', icon: '🎒', label: 'Voor school', sub: 'Etui, bidon, rugzak', types: ['Schoolspullen'], cols: ['islamitische-schoolspullen'] }
        ] },
        { id: 'voor', q: 'Is het voor een jongen of een meisje?', options: [
          { id: 'jongen', icon: '👦', label: 'Jongen', gender: 'm', kw: ['jongen', 'boy'] },
          { id: 'meisje', icon: '👧', label: 'Meisje', gender: 'f', kw: ['meisje', 'girl', 'moslima', 'hijab'] },
          { id: 'geen', icon: '🤷', label: 'Maakt niet uit', none: true }
        ] },
        budgetStep([[0, 10, '🪙'], [10, 20], [20, 35], [35, 9999, '💎']])
      ]
    }
  ];

  // Startscherm: volgorde van de tegels
  var START_TILES = [
    { flow: 'parfum' },
    { flow: 'boeken' },
    { flow: 'kleding' },
    { flow: 'verzorging' },
    { flow: 'cadeau' },
    { flow: 'gebed' },
    { flow: 'huisgeur' },
    { flow: 'kids' }
  ];

  // Oude gedeelde links (?pz=koran, ?pz=kinderboeken) openen de samengevoegde categorie
  var LEGACY_FLOWS = {
    koran: { flow: 'boeken', preset: { voor: 'koran' } },
    kinderboeken: { flow: 'boeken', preset: { voor: 'kind' } }
  };

  /* ------------------------------------------------------------------ */
  /*  2. Hulpjes voor productdata                                        */
  /* ------------------------------------------------------------------ */

  var AGE_BUCKETS = { baby: [0, 3], kleuter: [3, 6], kind6: [6, 9], kind9: [9, 12], tiener: [12, 18], volw: [18, 99] };
  var AGE_LABEL = { baby: '0–3 jaar', kleuter: '3–6 jaar', kind6: '6–9 jaar', kind9: '9–12 jaar', tiener: 'tieners', volw: 'volwassenen', kind: 'kinderen' };

  function lc(s) { return (s || '').toString().toLowerCase(); }

  function ageSet(p) {
    if (p._ages) return p._ages;
    var set = {};
    function add(lo, hi) { Object.keys(AGE_BUCKETS).forEach(function (k) { var b = AGE_BUCKETS[k]; if (b[0] < hi && b[1] > lo) set[k] = 1; }); }
    (p.a || []).forEach(function (raw) {
      var s = lc(raw), m;
      if (/alle leeftijden|universeel|all ages/.test(s)) add(0, 99);
      else if ((m = s.match(/(\d+)\s*-\s*(\d+)/))) add(+m[1], Math.max(+m[2], +m[1] + 1));
      else if ((m = s.match(/(\d+)\s*(jaar|years?)\s*(of ouder|or older|\+)/))) add(+m[1], 99);
      else if (/baby|peuter|toddler|infant/.test(s)) add(0, 3);
      else if (/kleuter/.test(s)) add(3, 6);
      else if (/schoolgaand/.test(s)) add(6, 12);
      else if (/kinderen|kids|children/.test(s)) add(3, 12);
      else if (/teen|tiener/.test(s)) add(12, 18);
      else if (/adult|volwassen/.test(s)) add(18, 99);
    });
    if (!Object.keys(set).length) {
      var cols = p.col || [];
      if (cols.indexOf('baby-peuterboeken') > -1) add(0, 6);
    }
    p._ages = set;
    return set;
  }

  function genderSet(p) {
    if (p._g) return p._g;
    var g = {};
    (p.g || []).concat(p.dg ? [p.dg] : []).forEach(function (raw) {
      var s = lc(raw);
      if (/vrouw|female|dames|women/.test(s)) g.f = 1;
      else if (/mann|male|heren|men/.test(s)) g.m = 1;
      else if (/unisex/.test(s)) g.u = 1;
      else if (/kids|kind/.test(s)) g.k = 1;
    });
    var t = ' ' + lc(p.t) + ' ';
    if (/\b(women|woman|femme|for her|pour elle|dames|meisje|girls?)\b/.test(t)) g.f = 1;
    if (/\b(men|man|homme|for him|pour homme|heren|jongen|boys?|ihram|ihraam)\b/.test(t)) g.m = 1;
    p._g = g;
    return g;
  }

  function hay(p) {
    if (p._hay) return p._hay;
    p._hay = { t: lc(p.t), x: lc((p.tg || []).join(' | ') + ' | ' + (p.d || '') + ' | ' + p.v) };
    return p._hay;
  }

  // Zoekwoord moet aan het begin van een woord staan: 'oud' past op 'Oudh', niet op 'goud'
  function kwRe(o) {
    if (!o._re) o._re = new RegExp('(?:^|[^a-z0-9\u00c0-\u024f])(?:' + o.kw.map(function (k) { return k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'i');
    return o._re;
  }
  function xkwRe(o) {
    if (!o._xre) o._xre = kwRe({ kw: o.xkw });
    return o._xre;
  }
  function rkwRe(o) {
    if (!o._rre) o._rre = kwRe({ kw: o.rkw });
    return o._rre;
  }
  function nkwRe(o) {
    if (!o._nre) o._nre = kwRe({ kw: o.nkw });
    return o._nre;
  }

  function hasCol(p, cols) { var c = p.col || []; for (var i = 0; i < cols.length; i++) if (c.indexOf(cols[i]) > -1) return true; return false; }

  /* ------------------------------------------------------------------ */
  /*  3. Score-model                                                     */
  /* ------------------------------------------------------------------ */

  // Hoe goed past één gekozen antwoord bij een product?
  function matchOption(p, o) {
    var s = 0, hit = false, h = hay(p);
    if (o.fam) {
      var fams = (p.f || []).map(lc);
      if (o.fam.some(function (f) { return fams.indexOf(f) > -1; })) { s += 4; hit = true; }
    }
    if (o.cols && hasCol(p, o.cols)) { s += 4; hit = true; }
    if (o.kw) {
      var re = kwRe(o), inT = re.test(h.t), inX = !inT && re.test(h.x);
      if (inT) { s += 3; hit = true; } else if (inX) { s += 1.5; hit = hit || !o.fam; }
    }
    if (o.rkw && !rkwRe(o).test(h.t)) return { s: -99, hit: false, x: true };
    if (o.xkw && xkwRe(o).test(h.t)) return { s: -99, hit: false, x: true };
    if (o.nkw && nkwRe(o).test(h.t)) s -= 3;
    else if (o.hitIfNot && o.nkw) { s += 1; hit = true; }
    if (o.tags) {
      var tg = (p.tg || []).map(lc);
      if (o.tags.some(function (t) { return tg.indexOf(t) > -1; })) { s += 2; hit = true; }
    }
    if (o.occ) {
      var oc = (p.o || []).map(lc);
      if (o.occ.some(function (t) { return oc.indexOf(t) > -1; })) { s += 2; hit = true; }
    }
    if (o.kaft && p.kf && o.kaft.indexOf(p.kf) > -1) { s += 2; hit = true; }
    return { s: s, hit: hit };
  }

  function scoreProduct(p, ctx, level) {
    var score = 0, why = [], hits = 0;
    function reason(r) { if (r && why.indexOf(r) < 0) why.push(r); }

    // Uitsluiten wat niet in deze zoeker hoort
    if (ctx.exclude.length && ctx.exclude.indexOf(p.ty) > -1) return null;
    if (ctx.baseTypes && ctx.baseTypes.indexOf(p.ty) < 0) return null;

    // Producttype: wat de klant koos (bijv. bakhour, parfumolie) blijft altijd verplicht
    if (ctx.types) {
      if (ctx.types.indexOf(p.ty) < 0) return null;
      hits++;
    }

    // Budget op de prijs van de hoofdvariant (bijv. de grote fles, niet het sample)
    if (ctx.budget && level < 2) {
      var eur = p.p / 100, tol = level === 1 ? 0.25 : 0;
      if (eur < ctx.budget[0] * (1 - tol) || eur > ctx.budget[1] * (1 + tol)) return null;
      if (eur >= ctx.budget[0] && eur <= ctx.budget[1]) reason('Binnen je budget');
    }

    // Geslacht
    if (ctx.gender) {
      var g = genderSet(p);
      if (ctx.gender === 'f' || ctx.gender === 'm') {
        var other = ctx.gender === 'f' ? 'm' : 'f';
        if (g[ctx.gender]) { score += 5; reason(ctx.gender === 'f' ? 'Voor haar' : 'Voor hem'); }
        else if (g.u) { score += 2; reason('Unisex'); }
        else if (g[other]) { if (level < 2) return null; score -= 6; }
      } else if (ctx.gender === 'u') {
        if (g.u) { score += 5; reason('Unisex'); }
        else if (g.f && g.m) score += 2;
        else if (g.f || g.m) score -= 3;
      }
    }

    // Leeftijd
    if (ctx.age) {
      var ages = ageSet(p), keys = Object.keys(ages);
      var want = ctx.age === 'kind' ? ['baby', 'kleuter', 'kind6', 'kind9'] : [ctx.age];
      if (keys.length) {
        if (want.some(function (w) { return ages[w]; })) { score += 5; reason('Geschikt voor ' + AGE_LABEL[ctx.age]); }
        else { if (level < 1 && ctx.ageStrict) return null; score -= 6; }
      }
    }

    // Taal
    if (ctx.lang) {
      if (p.tl) {
        if (ctx.lang.indexOf(p.tl) > -1) { score += 5; reason(p.tl.replace(' - ', '–')); }
        else { if (level < 1) return null; score -= 5; }
      } else {
        var c = p.col || [];
        var guess = c.indexOf('engelse-boeken') > -1 ? 'Engels' : c.indexOf('arabische-boeken') > -1 ? 'Arabisch' : null;
        if (guess && ctx.lang.indexOf(guess) > -1) score += 3;
        else if (guess) { if (level < 1) return null; score -= 5; }
        else score -= 1;
      }
    }

    // Voorkeuren uit de gekozen antwoorden
    for (var i = 0; i < ctx.prefs.length; i++) {
      var pref = ctx.prefs[i], any = false, best = 0;
      for (var j = 0; j < pref.options.length; j++) {
        var m = matchOption(p, pref.options[j]);
        if (m.x) return null;
        if (m.hit) { any = true; hits++; if (!pref.options[j].age && !pref.options[j].gender) reason(pref.options[j].label); }
        best = Math.max(best, m.s);
        score += m.s * (j === 0 ? 1 : 0.8);
      }
      if (pref.must && !any) { if (level < 1) return null; score -= 5; }
    }

    // Populariteit (feed is gesorteerd op best verkocht)
    score += 3 * (1 - p.rank);
    if (p.rank < 0.04) reason('Bestseller');
    var tg = (p.tg || []).map(lc);
    if (tg.indexOf('topproduct') > -1 || tg.indexOf('top25') > -1 || tg.indexOf('topcadeau') > -1) score += 1;
    if (p.r >= 4.5 && p.rc >= 3) { score += 1; reason('★ ' + p.r.toFixed(1).replace('.', ',') + ' (' + p.rc + ')'); }

    // Op het ruimste niveau alleen producten die tenminste ergens op aansluiten
    if (level >= 1 && !hits && ctx.prefs.length) return null;
    return { p: p, score: score, why: why };
  }

  function baseName(t) { return lc(t).split(/\s[-–]\s/)[0].replace(/\s+(edp|edt|parfumolie|parfum|eau de parfum)$/, '').trim(); }

  function rank(products, ctx, want) {
    var out = null, level = 0;
    for (level = 0; level < 3; level++) {
      out = [];
      for (var i = 0; i < products.length; i++) { var r = scoreProduct(products[i], ctx, level); if (r) out.push(r); }
      if (out.length >= Math.min(3, want)) break;
    }
    out.sort(function (a, b) { return b.score - a.score; });
    // Variatie: één per productlijn en max. 3 per merk
    var picked = [], seen = {}, vend = {};
    out.forEach(function (r) {
      var b = baseName(r.p.t), v = lc(r.p.v);
      if (seen[b]) return;
      if ((vend[v] || 0) >= 3 && ctx.diverse) return;
      seen[b] = 1; vend[v] = (vend[v] || 0) + 1; picked.push(r);
    });
    if (picked.length < want) out.forEach(function (r) { if (picked.indexOf(r) < 0 && picked.length < want * 3) picked.push(r); });
    return { list: picked, level: Math.min(level, 2), total: out.length };
  }

  /* ------------------------------------------------------------------ */
  /*  4. Data laden                                                      */
  /* ------------------------------------------------------------------ */

  var memCache = {};

  function storeGet(k) { try { var v = JSON.parse(sessionStorage.getItem(k)); if (v && Date.now() - v.t < 1800000) return v.d; } catch (e) {} return null; }
  function storeSet(k, d) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {} }

  function loadCollection(handle, cfg) {
    if (memCache[handle]) return memCache[handle];
    var key = 'pz3:' + handle + ':' + cfg.pages;
    var cached = storeGet(key);
    if (cached) return (memCache[handle] = Promise.resolve(cached));
    if (cfg.sample) {
      var ids = (cfg.sample.lists && cfg.sample.lists[handle]) || [];
      var s = ids.map(function (id, i) { return Object.assign({}, cfg.sample.products[id], { rank: i / Math.max(ids.length, 1) }); });
      return (memCache[handle] = new Promise(function (res) { setTimeout(function () { res(s); }, 250); }));
    }
    var all = [];
    function page(n) {
      var url = cfg.root + 'collections/' + encodeURIComponent(handle) + '?view=zoeker&sort_by=best-selling&page=' + n;
      return fetch(url, { credentials: 'same-origin' }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      }).then(function (txt) { return JSON.parse(txt); });
    }
    // Pagina 1 vertelt hoeveel pagina's er zijn; de rest tegelijk ophalen
    memCache[handle] = page(1).then(function (first) {
      all = first.products || [];
      var n = Math.min(first.pages || 1, cfg.pages), rest = [];
      for (var i = 2; i <= n; i++) rest.push(page(i).catch(function () { return { products: [] }; }));
      return Promise.all(rest).then(function (pages) { pages.forEach(function (d) { all = all.concat(d.products || []); }); });
    }).then(function () {
      var n = all.length;
      all.forEach(function (p, i) { p.rank = i / Math.max(n, 1); });
      storeSet(key, all);
      return all;
    }).catch(function (e) { delete memCache[handle]; throw e; });
    return memCache[handle];
  }

  function loadSources(handles, cfg) {
    return Promise.all(handles.map(function (h) {
      return loadCollection(h, cfg).catch(function () { return []; });
    })).then(function (lists) {
      var byId = {}, merged = [];
      lists.forEach(function (list) {
        list.forEach(function (p) {
          var ex = byId[p.id];
          if (!ex) { ex = byId[p.id] = Object.assign({}, p); merged.push(ex); }
          else ex.rank = Math.min(ex.rank, p.rank);
        });
      });
      return merged;
    });
  }

  /* ------------------------------------------------------------------ */
  /*  5. Interface                                                       */
  /* ------------------------------------------------------------------ */

  function esc(s) { return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) { return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' }); }
  function track(ev, data) { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ev }, data || {})); } catch (e) {} }
  function flowById(id) { for (var i = 0; i < FLOWS.length; i++) if (FLOWS[i].id === id) return FLOWS[i]; return null; }

  function Finder(root, cfg) {
    this.root = root;
    this.cfg = cfg;
    this.flow = null;
    this.answers = {};
    this.history = [];
    this.shown = cfg.results;
    this.body = root.querySelector('[data-pz-body]');
    this.bar = root.querySelector('[data-pz-bar]');
    this.live = root.querySelector('[data-pz-live]');
    var self = this;
    root.addEventListener('click', function (e) { self.onClick(e); });
    if (!this.restore()) this.renderStart();
  }

  Finder.prototype.enabledTiles = function () {
    var on = this.cfg.flows;
    return START_TILES.filter(function (t) { return !on || on[t.id || t.flow] !== false; });
  };

  Finder.prototype.visibleSteps = function () {
    var a = this.answers;
    return this.flow.steps.filter(function (s) {
      if (!s.when) return true;
      return Object.keys(s.when).every(function (k) { return s.when[k].indexOf(a[k]) > -1 || (Array.isArray(a[k]) && a[k].some(function (v) { return s.when[k].indexOf(v) > -1; })); });
    });
  };

  Finder.prototype.sources = function () {
    var s = this.flow.sources;
    return typeof s === 'function' ? s(this.answers) : s;
  };

  Finder.prototype.prefetch = function () {
    if (!this.flow) return;
    var self = this;
    this.sources().forEach(function (h) { loadCollection(h, self.cfg).catch(function () {}); });
  };

  Finder.prototype.focusTitle = function () {
    var h = this.body.querySelector('h2, h3');
    if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); } }
    var top = this.root.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.6) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Finder.prototype.setProgress = function (frac) {
    this.bar.style.width = Math.round(frac * 100) + '%';
    this.bar.parentNode.setAttribute('aria-valuenow', Math.round(frac * 100));
    this.bar.parentNode.hidden = frac <= 0;
  };

  Finder.prototype.renderStart = function () {
    this.flow = null; this.answers = {}; this.history = []; this.presetKeys = [];
    this.setProgress(0);
    this.root.classList.remove('pz--results');
    var tiles = this.enabledTiles().map(function (t) {
      var f = flowById(t.flow);
      return '<button type="button" class="pz-tile" data-pz-flow="' + esc(t.flow) + '"' + (t.preset ? ' data-pz-preset="' + esc(JSON.stringify(t.preset)) + '"' : '') + '>' +
        '<span class="pz-ico" aria-hidden="true">' + (t.icon || f.icon) + '</span>' +
        '<span class="pz-tile-txt"><span class="pz-tile-t">' + esc(t.label || f.label) + '</span>' +
        '<span class="pz-tile-s">' + esc(t.sub || f.sub) + '</span></span></button>';
    }).join('');
    // Heeft de sectie al een eigen titel? Dan geen tweede kop boven de tegels.
    var hasHead = !!this.root.querySelector('.pz-head .pz-title-main');
    this.body.innerHTML =
      '<div class="pz-step pz-start' + (hasHead ? ' pz-start--bare' : '') + '">' +
      (hasHead
        ? '<h2 class="pz-sr">Waar ben je naar op zoek?</h2>'
        : '<h2 class="pz-q">Waar ben je naar op zoek?</h2><p class="pz-hint">Kies een categorie. Daarna stellen we 3 tot 5 korte vragen.</p>') +
      '<div class="pz-grid pz-grid--tiles" role="group" aria-label="Kies een categorie">' + tiles + '</div></div>';
    this.updateUrl(true);
  };

  Finder.prototype.startFlow = function (id, preset) {
    this.flow = flowById(id);
    if (!this.flow) return this.renderStart();
    this.answers = Object.assign({}, preset || {});
    this.presetKeys = Object.keys(preset || {});
    this.history = [];
    this.autoSkipped = {};
    this.skipToken = null;
    this.shown = this.cfg.results;
    track('productzoeker_start', { pz_flow: id });
    this.prefetch();
    this.next();
  };

  Finder.prototype.currentIndex = function () {
    var steps = this.visibleSteps();
    for (var i = 0; i < steps.length; i++) if (!(steps[i].id in this.answers)) return i;
    return steps.length;
  };

  Finder.prototype.next = function () {
    var steps = this.visibleSteps(), i = this.currentIndex();
    if (i >= steps.length) return this.renderResults();
    var step = steps[i], self = this;
    // Budgetvraag overslaan als er toch al weinig producten over zijn: een budget helpt dan niet meer
    var isBudget = step.options.some(function (o) { return o.budget; });
    if (!isBudget) return this.renderStep(step, i, steps.length);
    var token = this.skipToken = {};
    loadSources(this.sources(), this.cfg).then(function (products) {
      if (token !== self.skipToken) return;
      var res = rank(products, self.buildCtx(), self.cfg.results);
      if (res.level > 0 || res.total <= self.cfg.results) {
        self.answers[step.id] = 'geen';
        (self.autoSkipped = self.autoSkipped || {})[step.id] = 1;
        self.next();
      } else self.renderStep(step, i, steps.length);
    }).catch(function () {
      if (token === self.skipToken) self.renderStep(step, i, steps.length);
    });
  };

  // Vraagnummer zonder voorgeselecteerde vragen (bijv. de tegel 'Kinderboeken')
  Finder.prototype.stepLabel = function (step) {
    var pk = this.presetKeys || [];
    var steps = this.visibleSteps().filter(function (s) { return pk.indexOf(s.id) < 0; });
    var at = steps.indexOf(step);
    return 'vraag ' + (at + 1) + ' van ' + steps.length;
  };

  Finder.prototype.renderStep = function (step, i, n) {
    this.root.classList.remove('pz--results');
    this.setProgress((i + 0.15) / (n + 1));
    this.curStep = step;
    var multi = step.multi || 0;
    var sel = this.answers[step.id];
    var selArr = Array.isArray(sel) ? sel : sel ? [sel] : [];
    var opts = step.options.map(function (o) {
      var on = selArr.indexOf(o.id) > -1;
      return '<button type="button" class="pz-opt' + (on ? ' is-on' : '') + (o.none ? ' pz-opt--none' : '') + '" data-pz-opt="' + esc(o.id) + '" aria-pressed="' + on + '">' +
        '<span class="pz-ico" aria-hidden="true">' + (o.icon || '') + '</span>' +
        '<span class="pz-opt-txt"><span class="pz-opt-t">' + esc(o.label) + '</span>' +
        (o.sub ? '<span class="pz-opt-s">' + esc(o.sub) + '</span>' : '') + '</span>' +
        (multi ? '<span class="pz-check" aria-hidden="true"></span>' : '') + '</button>';
    }).join('');
    this.body.innerHTML =
      '<div class="pz-step">' +
      '<p class="pz-count">' + esc(this.flow.label) + ' · ' + this.stepLabel(step) + '</p>' +
      '<h2 class="pz-q">' + esc(step.q) + '</h2>' +
      (step.hint ? '<p class="pz-hint">' + esc(step.hint) + '</p>' : '') +
      '<div class="pz-grid' + (step.options.length > 6 ? ' pz-grid--dense' : '') + '" role="group" aria-label="' + esc(step.q) + '">' + opts + '</div>' +
      '<div class="pz-nav">' +
      '<button type="button" class="pz-btn pz-btn--ghost" data-pz-back>← Terug</button>' +
      (multi ? '<button type="button" class="pz-btn pz-btn--primary" data-pz-next' + (selArr.length ? '' : ' disabled') + '>Volgende →</button>' : '') +
      '</div></div>';
    this.focusTitle();
  };

  Finder.prototype.choose = function (optId) {
    var step = this.curStep; if (!step) return;
    var opt = step.options.filter(function (o) { return o.id === optId; })[0];
    if (!opt) return;
    if (step.multi) {
      var cur = Array.isArray(this.answers[step.id]) ? this.answers[step.id].slice() : [];
      if (opt.none) cur = [opt.id];
      else {
        cur = cur.filter(function (id) { return !step.options.some(function (o) { return o.id === id && o.none; }); });
        var at = cur.indexOf(opt.id);
        if (at > -1) cur.splice(at, 1);
        else { cur.push(opt.id); if (cur.length > step.multi) cur.shift(); }
      }
      if (cur.length) this.answers[step.id] = cur; else delete this.answers[step.id];
      var self = this;
      this.body.querySelectorAll('[data-pz-opt]').forEach(function (b) {
        var on = cur.indexOf(b.getAttribute('data-pz-opt')) > -1;
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on);
      });
      var nb = this.body.querySelector('[data-pz-next]');
      if (nb) nb.disabled = !cur.length;
      if (opt.none) { this.history.push(step.id); setTimeout(function () { self.next(); }, 180); }
      return;
    }
    this.answers[step.id] = opt.id;
    this.history.push(step.id);
    // Antwoorden van stappen die nu niet meer zichtbaar zijn weggooien
    var vis = this.visibleSteps().map(function (s) { return s.id; }), a = this.answers;
    Object.keys(a).forEach(function (k) { if (vis.indexOf(k) < 0) delete a[k]; });
    if (typeof this.flow.sources === 'function') this.prefetch();
    var btn = this.body.querySelector('[data-pz-opt="' + optId + '"]');
    if (btn) { btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); }
    var self2 = this;
    setTimeout(function () { self2.next(); }, 160);
  };

  Finder.prototype.back = function () {
    if (!this.flow) return;
    this.skipToken = null;
    var steps = this.visibleSteps(), i = this.currentIndex();
    if (this.root.classList.contains('pz--results')) i = steps.length;
    if (i === 0) return this.renderStart();
    var prev = steps[i - 1];
    // Voorgeselecteerde startvraag (bijv. kinderboeken) overslaan
    if (this.autoSkipped && this.autoSkipped[prev.id]) {
      // Automatisch overgeslagen budgetvraag: ook de vraag daarvoor wissen, anders is 'Terug' een lus
      delete this.answers[prev.id]; delete this.autoSkipped[prev.id];
      if (i - 2 < 0) return this.renderStart();
      prev = steps[i - 2];
      i = i - 1;
    }
    delete this.answers[prev.id];
    if (i - 1 === 0 && this.presetFirst) return this.renderStart();
    this.renderStep(prev, i - 1, steps.length);
  };

  // Eén antwoord wijzigen: de rest blijft staan, daarna direct weer naar de resultaten
  Finder.prototype.editStep = function (id) {
    var steps = this.visibleSteps();
    var idx = steps.map(function (s) { return s.id; }).indexOf(id);
    if (idx < 0) return;
    this.skipToken = null;
    var a2 = this.answers, sk = this.autoSkipped || {};
    Object.keys(sk).forEach(function (k) { delete a2[k]; });
    this.autoSkipped = {};
    delete this.answers[id];
    this.renderStep(steps[idx], idx, steps.length);
  };

  Finder.prototype.buildCtx = function () {
    var a = this.answers, ctx = { prefs: [], exclude: this.flow.excludeTypes || [], baseTypes: this.flow.types || null, diverse: true };
    this.visibleSteps().forEach(function (step) {
      var val = a[step.id]; if (val == null) return;
      var ids = Array.isArray(val) ? val : [val];
      var opts = step.options.filter(function (o) { return ids.indexOf(o.id) > -1 && !o.none; });
      if (!opts.length) return;
      var pref = { options: [], must: !!step.must }, stepTypes = null;
      opts.forEach(function (o) {
        if (o.budget) ctx.budget = o.budget;
        if (o.excludeTypes) ctx.exclude = ctx.exclude.concat(o.excludeTypes);
        if (o.gender) ctx.gender = o.gender;
        if (o.age) { ctx.age = o.age; ctx.ageStrict = step.id === 'leeftijd'; }
        if (o.lang) ctx.lang = (ctx.lang && step.id !== 'taal' && step.id !== 'ktaal') ? ctx.lang : o.lang;
        if (o.types) stepTypes = (stepTypes || []).concat(o.types);
        if (o.fam || o.cols || o.kw || o.tags || o.occ || o.kaft || o.nkw || o.xkw || o.rkw) pref.options.push(o);
      });
      if (pref.options.length) ctx.prefs.push(pref);
      if (stepTypes) {
        // Twee vragen met producttypes (bijv. 'kind' + 'boek'): de overlap telt
        var both = ctx.types ? ctx.types.filter(function (t) { return stepTypes.indexOf(t) > -1; }) : [];
        ctx.types = both.length ? both : stepTypes;
      }
    });
    return ctx;
  };

  Finder.prototype.answerChips = function () {
    var a = this.answers, out = [];
    var sk = this.autoSkipped || {};
    this.visibleSteps().forEach(function (step) {
      var val = a[step.id]; if (val == null || sk[step.id]) return;
      var ids = Array.isArray(val) ? val : [val];
      var labels = step.options.filter(function (o) { return ids.indexOf(o.id) > -1; }).map(function (o) { return o.label; });
      out.push('<button type="button" class="pz-chip" data-pz-edit="' + esc(step.id) + '" title="Wijzig: ' + esc(step.q) + '">' + esc(labels.join(' + ')) + ' <span aria-hidden="true">✎</span></button>');
    });
    return out.join('');
  };

  Finder.prototype.renderResults = function () {
    var self = this, flow = this.flow;
    this.shown = this.cfg.results;
    this.curStep = null;
    this.setProgress(1);
    this.root.classList.add('pz--results');
    this.updateUrl();
    var skeleton = '';
    for (var i = 0; i < Math.min(this.shown, 6); i++) skeleton += '<div class="pz-card pz-card--skel"><div class="pz-img"></div><div class="pz-card-b"><span></span><span></span><span></span></div></div>';
    this.body.innerHTML =
      '<div class="pz-res">' +
      '<div class="pz-res-head"><h2 class="pz-q">Even zoeken…</h2><div class="pz-chips">' + this.answerChips() + '</div></div>' +
      '<div class="pz-cards" aria-busy="true">' + skeleton + '</div></div>';
    var token = this.token = {};
    loadSources(this.sources(), this.cfg).then(function (products) {
      if (token !== self.token) return;
      var res = rank(products, self.buildCtx(), self.shown);
      self.lastRes = res;
      self.paintResults(res);
      track('productzoeker_complete', { pz_flow: flow.id, pz_answers: JSON.stringify(self.answers), pz_results: res.list.length });
    }).catch(function () {
      if (token !== self.token) return;
      self.paintResults({ list: [], level: 2, total: 0, error: true });
    });
  };

  Finder.prototype.paintResults = function (res) {
    var flow = this.flow, cfg = this.cfg, more = flow.more ? flow.more(this.answers) : null;
    var list = res.list.slice(0, this.shown);
    var head = list.length
      ? (res.level === 0 ? 'Dit past bij jou' : 'Dit komt het dichtst in de buurt')
      : 'Helaas, geen goede match gevonden';
    var note = '';
    if (list.length && res.level > 0) note = '<p class="pz-note">We vonden weinig producten die precies aan al je wensen voldoen, dus we hebben de zoektocht iets verruimd' + ((this.answers.budget && this.answers.budget !== 'geen') || (this.answers.kbudget && this.answers.kbudget !== 'geen') ? ' (bijvoorbeeld het budget)' : '') + '.</p>';
    if (res.error) note = '<p class="pz-note">De producten konden even niet geladen worden. Probeer het opnieuw of bekijk de collectie hieronder.</p>';

    var cards = list.map(function (r, i) {
      var p = r.p, sale = p.c && p.c > p.p;
      var img = p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.t) + '" data-pid="' + esc(p.id) + '" loading="lazy" width="400" height="400">' : '<span class="pz-noimg" aria-hidden="true">📦</span>';
      var why = r.why.slice(0, 3).map(function (w) { return '<li>' + esc(w) + '</li>'; }).join('');
      var price = (p.pm && p.pm < p.p ? '<span class="pz-from">vanaf ' + money(p.pm) + ' · </span>' : '') +
        '<span class="pz-price' + (sale ? ' is-sale' : '') + '">' + money(p.p) + '</span>' + (sale ? ' <s>' + money(p.c) + '</s>' : '');
      return '<article class="pz-card' + (i === 0 ? ' pz-card--best' : '') + '">' +
        (i === 0 ? '<span class="pz-badge">Beste match</span>' : sale ? '<span class="pz-badge pz-badge--sale">Aanbieding</span>' : '') +
        '<a class="pz-img" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="pz-card-b">' +
        (p.v ? '<p class="pz-vendor">' + esc(p.v) + '</p>' : '') +
        '<h3 class="pz-title"><a href="' + esc(p.u) + '" data-pz-click="' + esc(p.h) + '">' + esc(p.t) + '</a></h3>' +
        (why ? '<ul class="pz-why" aria-label="Waarom dit past">' + why + '</ul>' : '') +
        '<p class="pz-prices">' + price + '</p>' +
        '<div class="pz-actions">' +
        (cfg.cart && p.vid ? '<button type="button" class="pz-btn pz-btn--primary pz-btn--sm" data-pz-add="' + esc(p.vid) + '" data-pz-title="' + esc(p.t) + '">In winkelwagen</button>' : '') +
        '<a class="pz-btn pz-btn--ghost pz-btn--sm" href="' + esc(p.u) + '">Bekijken</a>' +
        '</div></div></article>';
    }).join('');

    var moreBtn = res.list.length > list.length ? '<button type="button" class="pz-btn pz-btn--ghost" data-pz-more>Toon meer suggesties</button>' : '';
    var tip = flow.tip && list.length ? '<p class="pz-tip">🎀 ' + esc(flow.tip.text) + ' <a href="' + cfg.root + 'collections/' + esc(flow.tip.handle) + '">' + esc(flow.tip.label) + ' →</a></p>' : '';
    var empty = !list.length ? '<div class="pz-empty"><p>Probeer een antwoord aan te passen, of bekijk het hele aanbod.</p></div>' : '';

    this.body.innerHTML =
      '<div class="pz-res">' +
      '<div class="pz-res-head"><h2 class="pz-q">' + head + '</h2>' +
      '<p class="pz-hint">Op basis van je antwoorden. Klik op een antwoord om het te wijzigen.</p>' +
      '<div class="pz-chips">' + this.answerChips() + '</div></div>' + note + empty +
      (list.length ? '<div class="pz-cards">' + cards + '</div>' : '') +
      '<div class="pz-res-foot">' + moreBtn + tip +
      '<div class="pz-nav">' +
      '<button type="button" class="pz-btn pz-btn--ghost" data-pz-back>← Terug</button>' +
      '<button type="button" class="pz-btn pz-btn--ghost" data-pz-restart>↺ Opnieuw beginnen</button>' +
      (more ? '<a class="pz-btn pz-btn--primary" href="' + cfg.root + 'collections/' + esc(more) + '">Bekijk alles in deze categorie →</a>' : '') +
      '</div></div></div>';
    this.live.textContent = list.length ? list.length + ' suggesties gevonden.' : 'Geen suggesties gevonden.';
    this.focusTitle();
  };

  Finder.prototype.addToCart = function (btn) {
    var id = btn.getAttribute('data-pz-add'), self = this;
    btn.disabled = true; btn.textContent = 'Toevoegen…';
    var done = function (ok) {
      btn.textContent = ok ? '✓ Toegevoegd' : 'Mislukt, probeer opnieuw';
      btn.classList.toggle('is-done', ok);
      btn.disabled = ok;
      if (ok) {
        self.toast('Toegevoegd aan je winkelwagen', self.cfg.root + 'cart', 'Naar winkelwagen');
        track('productzoeker_add_to_cart', { pz_flow: self.flow && self.flow.id, pz_variant: id });
        self.refreshCart();
      }
    };
    if (this.cfg.sample) return setTimeout(function () { done(true); }, 400);
    fetch(this.cfg.root + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { done(r.ok); }).catch(function () { done(false); });
  };

  // Teller in de header bijwerken en bekende winkelwagen-widgets laten verversen.
  // Let op: Shopify.onCartUpdate wordt bewust niet aangeroepen (standaard is dat een alert).
  Finder.prototype.refreshCart = function () {
    fetch(this.cfg.root + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count], .cart-count-bubble span, .cart-count').forEach(function (el) {
        if (el.children.length === 0) el.textContent = cart.item_count;
      });
      try { if (window.__globeCart && typeof window.__globeCart.fetchCart === 'function') window.__globeCart.fetchCart(); } catch (e) {}
      ['cart:refresh', 'cart:updated'].forEach(function (n) { try { document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: cart } })); } catch (e) {} });
    }).catch(function () {});
  };

  Finder.prototype.toast = function (msg, href, label) {
    var t = this.root.querySelector('.pz-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pz-toast'; t.setAttribute('role', 'status'); this.root.appendChild(t); }
    t.innerHTML = '<span>✓ ' + esc(msg) + '</span> <a href="' + esc(href) + '">' + esc(label) + ' →</a>';
    t.classList.add('is-on');
    clearTimeout(this._tt);
    this._tt = setTimeout(function () { t.classList.remove('is-on'); }, 5000);
  };

  Finder.prototype.onClick = function (e) {
    var el = e.target.closest('button, a'); if (!el || !this.root.contains(el)) return;
    if (el.hasAttribute('data-pz-flow')) {
      var preset = el.getAttribute('data-pz-preset');
      this.presetFirst = !!preset;
      return this.startFlow(el.getAttribute('data-pz-flow'), preset ? JSON.parse(preset) : null);
    }
    if (el.hasAttribute('data-pz-opt')) return this.choose(el.getAttribute('data-pz-opt'));
    if (el.hasAttribute('data-pz-next')) return this.next();
    if (el.hasAttribute('data-pz-back')) return this.back();
    if (el.hasAttribute('data-pz-restart')) { this.presetFirst = false; return this.renderStart(); }
    if (el.hasAttribute('data-pz-edit')) return this.editStep(el.getAttribute('data-pz-edit'));
    if (el.hasAttribute('data-pz-more')) { this.shown += this.cfg.results; return this.paintResults(this.lastRes); }
    if (el.hasAttribute('data-pz-add')) return this.addToCart(el);
    if (el.hasAttribute('data-pz-click')) track('productzoeker_click', { pz_flow: this.flow && this.flow.id, pz_product: el.getAttribute('data-pz-click') });
  };

  /* ---- Deelbare link: ?pz=parfum&pza=voor:haar|geur:zoet,oud ---- */
  Finder.prototype.updateUrl = function (clear) {
    if (!this.cfg.url || !window.history || !history.replaceState) return;
    try {
      var u = new URL(location.href);
      u.searchParams.delete('pz'); u.searchParams.delete('pza');
      if (!clear && this.flow) {
        var a = this.answers;
        u.searchParams.set('pz', this.flow.id);
        u.searchParams.set('pza', Object.keys(a).map(function (k) { return k + ':' + [].concat(a[k]).join(','); }).join('|'));
      }
      history.replaceState(history.state, '', u.toString());
    } catch (e) {}
  };

  Finder.prototype.restore = function () {
    var q;
    try { q = new URL(location.href).searchParams; } catch (e) { return false; }
    var id = q.get('pz') || q.get('zoeker') || this.cfg.startFlow;
    if (!id) return false;
    var legacy = LEGACY_FLOWS[id] || null;
    if (legacy) id = legacy.flow;
    var tile = START_TILES.filter(function (t) { return (t.id || t.flow) === id; })[0];
    var flow = flowById(tile ? tile.flow : id);
    if (!flow) return false;
    this.flow = flow;
    var a = {};
    (q.get('pza') || '').split(/[|;]/).forEach(function (pair) {
      var kv = pair.split(':'); if (kv.length !== 2) return;
      var step = flow.steps.filter(function (s) { return s.id === kv[0]; })[0]; if (!step) return;
      var vals = kv[1].split(',').filter(function (v) { return step.options.some(function (o) { return o.id === v; }); });
      if (!vals.length) return;
      a[kv[0]] = step.multi ? vals : vals[0];
    });
    if (legacy) Object.assign(a, legacy.preset);
    if (tile && tile.preset) { Object.assign(a, tile.preset); this.presetFirst = true; this.presetKeys = Object.keys(tile.preset); }
    this.answers = a;
    this.prefetch();
    this.next();
    return true;
  };

  /* ------------------------------------------------------------------ */
  /*  6. Starten                                                         */
  /* ------------------------------------------------------------------ */

  function init(el) {
    if (el.__pz) return;
    var cfg = {};
    try { cfg = JSON.parse((el.querySelector('script[data-pz-config]') || {}).textContent || '{}'); } catch (e) {}
    cfg.root = (cfg.root || (window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
    cfg.pages = cfg.pages || 4;
    cfg.results = cfg.results || 6;
    cfg.cart = cfg.cart !== false;
    cfg.url = cfg.url !== false;
    if (window.PZ_SAMPLE) cfg.sample = window.PZ_SAMPLE;
    el.__pz = new Finder(el, cfg);
  }

  function boot() { document.querySelectorAll('[data-pz]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);

  function plan(id, answers) {
    var f = Object.create(Finder.prototype); f.flow = flowById(id); f.answers = answers || {};
    return { ctx: f.buildCtx(), sources: f.sources(), steps: f.visibleSteps().map(function (s) { return s.id; }) };
  }
  window.Productzoeker = { FLOWS: FLOWS, rank: rank, plan: plan, boot: boot };
})();
